import { render, staticRenderFns } from "./editChannel.vue?vue&type=template&id=0cfe777c"
import script from "./editChannel.vue?vue&type=script&lang=js"
export * from "./editChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports